module.exports = __webpack_public_path__ + "img/beta.3de765a2.png";